import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    smsSystemDeleteRequest,
    clearRedux,
} from 'Redux/actions';

const DeleteSmsSystem = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const {
        openModal,
        loading,
        current,
        result
    } = useSelector(state => state.deleteSmsSystemRedux);

    const closeModal = () => {
        dispatch(clearRedux("SMS_SYSTEM_DELETE"))
    }

    const deleteSimProvider = () => {
        dispatch(smsSystemDeleteRequest(current?.id))
    }

    useEffect(() => {
        if (result) {
            if (result?.delete) {
                NotificationManager.success(
                    messages['delete_sms_system_success_message'],
                    messages['delete_sms_system_title'],
                    3000
                );
                tableRef && tableRef?.current?.getData();
                closeModal();
            } else {
                NotificationManager.error(
                    messages['delete_sms_system_error_message'],
                    messages['delete_sms_system_title'],
                    3000
                );
                dispatch(clearRedux("SMS_SYSTEM_DELETE", { result: null }))
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={`${messages['delete_sms_system_title']} (${current?.name})`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    <span>{messages['delete_sms_system_label']}</span>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => deleteSimProvider()}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteSmsSystem;